module.exports = __webpack_public_path__ + "assets/img/title3.35253778.png";